<div class="content-layout">
  <property-header></property-header>

  <router-outlet></router-outlet>
</div>
